import { DateRangePicker } from "react-date-range";
import styled from "styled-components";
export const DateBox = styled.div`
  display: "flex";
  position: relative;
`;
export const DateRange = styled(DateRangePicker)`
  position: absolute;
  display: none !important;
  top: 50px;
  border-radius: 10px;
  &.true {
    display: flex !important;
    z-index: 1001;
  }
`;
export const Filter = styled.button`
  background: transparent;
  padding: 0 0.5em;
  font-size: 1em;
  margin-right: 0.5em;
  outline: none;
  border: 0px solid #ddd;
  text-wrap: nowrap;
  cursor: pointer;
  height: 40px;
  margin-right: 10px;
  padding: 12px;
  background: ${(props) => props.theme.background};
  border-radius: 12px;
  margin-top: 4px;
  cursor: pointer;
  font-weight: 700;
  font-size: 13.5px;
  display:flex;
  justify-content:center;
  align-items:center;
  div{
    display: flex;
  }
  &:hover {
    color: ${(props) => props.theme.bgPrimary};
  }
`;
